export default __webpack_public_path__ + "static/media/parking-3.2937304b.jpg";